import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class RecommendedActions extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'RecommendedActions'
  // Define default properties here
  static instanceDefaults () {
    return {
      isEnabled: false,
      defaultTranslation: null,
      rating: 0,
      isRecommended: null,
      subCategoryId: null,
      compassSubCategoryId: null,
      categoryId: null,
    }
  }
}

const servicePath = 'recommended-actions'
const servicePlugin = makeServicePlugin({
  Model: RecommendedActions,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
